<template>

</template>

<script>
  export default {
     name: 'CheckSetting',
     data () {
       return {
       
        };
     },
     methods: {

     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Check/CheckSetting.vue